import { useEffect, useState } from "react";
import { api } from "../lib/api";
import Pricing from "./Pricing";
import PricingComingSoon from "./PricingComingSoon";

export default function PricingAvailability() {
  const [available, setAvailable] = useState(false);
  useEffect(() => {
    let mounted = true;
    // [plans.launch-availability](../../../docs/product/plans-and-referrals.md#plans-launch-availability): default to Coming Soon; load the catalog only after launch is confirmed.
    api.paidPlansAvailability().then((status) => {
      if (mounted) setAvailable(status.paidPlansAvailable === true);
    }).catch(() => { /* Keep the launch pause when availability cannot be confirmed. */ });
    return () => { mounted = false; };
  }, []);
  return available ? <Pricing /> : <PricingComingSoon />;
}
